import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { LegendPosition } from '@swimlane/ngx-charts';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { trigger, style, transition, animate } from '@angular/animations';
import { NgZone } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as _ from 'lodash';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';
import { closure_status_list } from '../shared/constants';
import moment from 'moment';
import { Moment } from 'moment';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-dashboard-hc',
	templateUrl: './dashboard-healthcube.component.html',
	styleUrls: ['./dashboard-healthcube.component.scss', '../../assets/styles/dashboard-styles.scss'],
	animations: [trigger('enterAnimation', [
		transition(':enter', [
			style({ transform: 'translateY(-100%)', opacity: 0 }),
			animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
		]),
		transition(':leave', [
			style({ transform: 'translateY(0)', opacity: 1 }),
			animate('500ms', style({ transform: 'translateY(-100%)', opacity: 0 }))
		])
	])]
})
export class DashboardHealthcubeComponent implements OnInit, AfterViewInit, OnDestroy {
	UserModuleAccess: any = "Full";
	showCard = false;
	colorScheme: any = {
		domain: ['#5AA454', '#ffe417', '#f72119', '#ffa01b', '#690000']
	};
	colorScheme1: any = {
		domain: ['#211bd1', '#ffe417', '#f72119', '#ffa01b', '#690000']
	};
	yAxisTicks: any[] = [0, 300, 600, 900, 1200];
	/* filterDates = (d: Date | null) => {
		const today = new Date();
		if (d == null) return false;
		return d <= today;
	} */
	today = new Date();
	// options
	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	@ViewChild(MatPaginator,) paginator!: MatPaginator;
	baseURL = environment.API_URL + "api/";
	dtOptions: Config = {};
	dataList: any = [];
	legend: boolean = true;
	showLabels: boolean = true;
	animations: boolean = true;
	xAxis: boolean = true;
	yAxis: boolean = true;
	showYAxisLabel: boolean = true;
	showXAxisLabel: boolean = true;
	timeline: boolean = true;
	mode: ProgressBarMode = 'determinate';
	value = 50;
	bufferValue = 75;
	bubbles: any
	balls: Array<{ top: number, left: number, vx: number, vy: number, text: string, num: number, bsize: any }> = [];
	containerWidth = 450;
	containerHeight = 420;
	ballSize = 50;
	intervalId: any;
	displayedColumns: string[] = ['sn', 'name', 'value'];  // Columns to display in the table
	dataSource = new MatTableDataSource<any>();        // Data source for the table
	totalItems = 100;                                        // Total number of items (used for pagination)
	pageSize = 10;
	selectDoctor: any = [];

	params: any = {
		selectDoctor: "",
		caseStatus: ""
	};
	caseStatus: any = ['Active', 'Closed', 'Repatriation', 'Reopen'];
	//----------------------//
	user_type: any = "";
	user: any = null;
	isCompanyIdNull = false;
	accessLoader = false;
	yearList: any[] = [];
	minDateForFilter = moment("2025-01-01", "YYYY-MM-DD");
	company_period_wise_count_loader = false;
	company_period_wise_count: any = {};
	all_zero_company_period_wise_count = false;
	getStartDate() {
		return this.isBefore(this.apiService.getDefaultDateRange1Month(false).start_date as any, /* this.firstDayOfYear */this.minDateForFilter) ? /* this.firstDayOfYear */this.minDateForFilter : this.apiService.getDefaultDateRange1Month(false).start_date as any;
	}
	isBefore(date1: Moment, date2: Moment): boolean {
		return date1.clone().startOf('day').isBefore(date2.clone().startOf('day'));
	}
	closure_status_list = closure_status_list;
	cardsFilter: any = {
		company_id: null,
		fleet_id: null,
		vessel_id: null,
		nationality: null,
		rank: null,
		start_date_analytics: this.apiService.getDefaultDateRange1Month(false).start_date,
		end_date_analytics: this.apiService.getDefaultDateRange1Month(false).end_date,
		user_id: null,
		start_date: this.getStartDate(),
		end_date: this.apiService.getDefaultDateRange1Month(false).end_date,
		owner_id: null,
		symptom: null/* { group_name: "INJURY", hc_id: 255 } */,
		sub_symptom: null,
		year: moment().year(),
		case_status: "Open",
		closure_status: null
	}

	constructor(private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private zone: NgZone, private datePipe: DatePipe, private http: HttpClient) {
		let yyyy = 2000;
		let currentYear = moment().year();
		while (yyyy <= currentYear) {
			/* let toYear: any = (yyyy + 1).toString().slice(2); */
			this.yearList.push({ value: yyyy, name: yyyy/*  + "-" + toYear */ });
			yyyy += 1;
		}
		this.yearList = this.yearList.reverse();
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.accessLoader = true;
			this.apiService.getUserAccess().subscribe({
				next: (data: any) => {
					this.accessLoader = false;
					console.log(data);
					try {
						this.user_type = data.res[0].user_type;
						this.user = data.res[0];
						this.cardsFilter.user_id = (data.res[0].UserId);
						let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
						this.UserModuleAccess = accessObj["HC_dashboard"];
						if (this.user_type != 'cdm') {
							let company = data.res[0].company_id[0];
							this.cardsFilter.company_id = company;
							this.rma_dashboard_fleet_dropdown(1);
							this.get_owners_dropdown();
							this.isCompanyIdNull = company.hc_id ? false : true;
							if (this.user_type == 'fleet') {
								let fleet = data.res[0].fleet_id[0];
								this.cardsFilter.fleet_id = fleet;
								this.rma_dashboard_vessel_dropdown();
							}

							/* this.initDatatable(); */
							this.doctor_list();
							/* this.rma_dashboard_symptoms_tags_graph(); */
							if (this.user_type == "cdm") {
								this.rma_dashboard_sub_symptoms_graph();
							}
							this.moveBalls();
							this.rma_dashboard_symptoms_dropdown();
							this.rma_dashboard_sub_symptoms_dropdown();
							this.rma_dashboard_nationality_dropdown();
							this.rma_dashboard_rank_dropdown();
						} else {
							if (sessionStorage.getItem("selectedCompanyFilter")) {
								try {
									let obj = JSON.parse(sessionStorage.getItem("selectedCompanyFilter")!);
									if (obj.hc_id) {
										this.cardsFilter.company_id = obj;
										this.rma_dashboard_fleet_dropdown(1);
										this.get_owners_dropdown();
									} else {
										this.getCompanyWiseData();
									}
								} catch (error) {
									this.getCompanyWiseData();
								}
							} else {
								this.getCompanyWiseData();
							}
							/* this.initDatatable(); */
							this.doctor_list();
							/* this.rma_dashboard_symptoms_tags_graph(); */
							if (this.user_type == "cdm") {
								this.rma_dashboard_sub_symptoms_graph();
							}
							this.moveBalls();
							this.rma_dashboard_symptoms_dropdown();
							this.rma_dashboard_sub_symptoms_dropdown();
							this.rma_dashboard_nationality_dropdown();
							this.rma_dashboard_company_dropdown();
							this.rma_dashboard_rank_dropdown();

						}
					} catch (error) { }
				}, error: (error: any) => {
					this.accessLoader = false;
					this.UserModuleAccess = "NoAccess";
				}
			});
		});
	}

	ngAfterViewInit(): void { }

	ngOnDestroy(): void {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: true,
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
					owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
					start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
					end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
					rank: this.cardsFilter.rank,
					nationality: this.cardsFilter.nationality,
					fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
					vessel_id: this.cardsFilter.vessel_id,
					searchVal: "",
					symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
					sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
				}
				if (dataTablesParameters.search.value != "") {
					data.searchVal = dataTablesParameters.search.value;
				}
				const httpParams: HttpParamsOptions = { data } as HttpParamsOptions;
				console.log(httpParams);
				this.http.post<DataTablesResponse>(this.baseURL + "rma_dashboard_vessel_wise_count", data).subscribe({
					next: (response: any) => {

						this.dataList = response.data_list;
						callback({
							recordsTotal: response.total_appt_vessel_count,
							recordsFiltered: response.total_appt_vessel_count,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Hmmm Something went wrong.", 'Error!!!', {
							timeOut: 5000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}


	doctor_list(): void {
		this.apiService.doctorList().subscribe((data: any) => {
			//console.log(data);
			this.selectDoctor = data.doctors;
		});
	}

	// Filter search results
	applyFilter(event: Event): void {
		const filterValue = (event.target as HTMLInputElement).value;
		this.dataSource.filter = filterValue.trim().toLowerCase();

		if (this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}
	}

	// Handle pagination
	onPageChange(event: PageEvent): void {
		this.pageSize = event.pageSize;
	}
	//symptoms_tag_data: any = [];
	rma_dashboard_symptoms_tags_graph() {
		let filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			rank: this.cardsFilter.rank,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			nationality: this.cardsFilter.nationality,
			/* symptom: "INJURY", */
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
		};
		this.apiService.rma_dashboard_symptoms_tags_graph(filter).subscribe({
			next: (data: any) => {
				let bubbleData: any[] = [];
				for (let i = 0; i < data.data_list.length; i++) {
					bubbleData.push({
						name: data.data_list[i].name,
						value: data.data_list[i].value,
						size: `${(data.data_list[i].value)}px`,
						color: "#555555"
						//	color: this.getRandomColor()
					});
				}
				this.bubbles = bubbleData;
				this.generateBalls(this.bubbles);
				//console.log(this.bubbles);
			}, error: (error) => {
				this.bubbles = [];
			}
		});
	}
	// Generate balls with random positions, velocities, and text
	generateBalls(balls: any[]): void {
		const { containerHeight, containerWidth, ballSize } = this;

		this.balls = balls.map(({ name, value }) => {
			const randomTop = Math.random() * (containerHeight - ballSize);
			const randomLeft = Math.random() * (containerWidth - ballSize);
			const randomVX = Math.random() * 0.9; // Velocity in X direction
			const randomVY = Math.random() * 0.9; // Velocity in Y direction

			return {
				top: randomTop,
				left: randomLeft,
				vx: randomVX,
				vy: randomVY,
				text: name,
				num: value,
				bsize: `${value}px`
			};
		});
	}

	//   generateBalls(balls:any): void {
	// 	let numBalls = balls.length;

	// 	for (let i = 0; i < numBalls; i++) {
	// 	  const randomTop = Math.random() * (this.containerHeight - this.ballSize);
	// 	  const randomLeft = Math.random() * (this.containerWidth - this.ballSize);
	// 	  const randomVX = Math.random() *0.9; // Velocity in X direction
	// 	  const randomVY = Math.random() *0.9; // Velocity in Y direction
	// 	  const randomText = balls[i].name;

	// 	  this.balls.push({
	// 		top: randomTop,
	// 		left: randomLeft,
	// 		vx: randomVX,
	// 		vy: randomVY,
	// 		text: randomText,
	// 		num: balls[i].value,
	// 		bsize:`${balls[i].value}px`
	// 	  });
	// 	}
	//   }

	// Move balls inside the container
	moveBalls(): void {
		this.intervalId = setInterval(() => {
			this.balls.forEach(ball => {
				ball.top += ball.vy;
				ball.left += ball.vx;

				// Check for boundary collision and reverse direction if needed
				if (ball.top <= 0 || ball.top >= this.containerHeight - this.ballSize) {
					ball.vy = -ball.vy; // Reverse Y direction
				}
				if (ball.left <= 0 || ball.left >= this.containerWidth - this.ballSize) {
					ball.vx = -ball.vx; // Reverse X direction
				}
			});
		}, 20); // Update every 20ms
	}
	//   deselectByIdClinical(id:any){
	// 	var arr:any = this.f.clinicalScale1.value;
	// 	const index = arr.indexOf(id);
	// 	arr.splice(index,1);
	// 	arr = [...arr];
	// }
	// getCompanyWiseData() {
	// 	this.initDatatable();
	// 	this.rma_dashborad_cases_by_month();
	// 	this.rma_dashboard_case_category_pie_chart();
	// 	this.rma_dashboard_company_period_wise_count();
	// 	this.rma_dashboard_top_5_med_cases_graph();
	// 	this.humanAnatomyAPIs();
	// 	this.rma_dashboard_symptoms_tags_graph();
	// 	this.rma_dashboard_sub_symptoms_graph();
	// }

	getCompanyWiseData() {
		if (this.user_type != "cdm") {
			if (
				this.cardsFilter.start_date &&
				(
					this.isBefore(this.cardsFilter.start_date, this.minDateForFilter) ||
					this.isBefore(moment(), this.cardsFilter.start_date)
				)
			) {
				this.toastr.error("Invalid start date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			}
			if (
				this.cardsFilter.end_date &&
				(
					this.isBefore(this.cardsFilter.end_date, this.minDateForFilter) ||
					this.isBefore(moment(), this.cardsFilter.end_date)
				)
			) {
				this.toastr.error("Invalid end date", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				return;
			}
		} else {
			this.humanAnatomyAPIs();
		}
		/* this.initDatatable(); */

		// Group API calls to improve readability and ensure they run in parallel

		this.loadRmaDashboardData();

		this.refreshActiveCases();
	}

	activeCases: any = [];
	isListFinished: boolean = false;
	activeCasesLoading: boolean = false;
	tableparams = {
		start: 0,
		length: 10,
	};
	ActiveCasesExcelLoader = false;
	ActiveCasesExcelExcelName = "Active Cases.xlsx";

	refreshActiveCases() {
		this.tableparams.start = 0;
		this.isListFinished = false;
		this.activeCases = [];
		this.rma_dashboard_active_cases_section(true);
	}

	rma_dashboard_active_cases_section(isSearch: boolean) {
		if (!this.isListFinished && !this.activeCasesLoading) {
			let params: any = {
				length: this.tableparams.length,
				start: this.tableparams.start,
				company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
				owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
				start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
				end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
				rank: this.cardsFilter.rank,
				nationality: this.cardsFilter.nationality,
				fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
				vessel_id: this.cardsFilter.vessel_id,
				symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
				sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
				case_status: this.cardsFilter.case_status,
				closure_status: this.cardsFilter.closure_status
			};
			this.activeCasesLoading = true;
			this.apiService.rma_dashboard_active_cases_section(params).subscribe({
				next: (data: any) => {
					this.activeCasesLoading = false;
					let list: any[] = data.active_cases;
					if (list.length == this.tableparams.length) {
						this.tableparams.start += this.tableparams.length;
					} else {
						this.isListFinished = true;
					}
					if (isSearch) {
						this.activeCases = [];
					}
					this.activeCases = this.activeCases.concat(list);
				}, error: (error) => {
					this.activeCasesLoading = false;
					this.isListFinished = true;
				}
			});
		}
	}

	getActiveCasesExcel() {
		let params: any = {
			/* length: this.tableparams.length,
			start: this.tableparams.start, */
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			rank: this.cardsFilter.rank,
			nationality: this.cardsFilter.nationality,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
			case_status: this.cardsFilter.case_status,
			closure_status: this.cardsFilter.closure_status
		};
		this.ActiveCasesExcelLoader = true;
		this.apiService.rma_dashboard_active_cases_section_excel_download(params).subscribe({
			next: res => {
				let excelData: any = res.body;
				this.ActiveCasesExcelLoader = false;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = this.ActiveCasesExcelExcelName;
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.ActiveCasesExcelLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	loadRmaDashboardData() {
		const dashboardAPIs = [
			this.rma_dashborad_cases_by_month(),
			this.rma_dashboard_company_period_wise_count(),
			this.rma_dashboard_top_5_med_cases_graph(),
			/* this.rma_dashboard_symptoms_tags_graph(), */
		];
		if (this.user_type == "cdm") {
			dashboardAPIs.push(this.rma_dashboard_sub_symptoms_graph());
			dashboardAPIs.push(this.rma_dashboard_case_category_pie_chart());
		}

		// Execute all dashboard-related API calls in parallel
		Promise.all(dashboardAPIs).catch(error => {
			console.error('Error loading RMA dashboard data:', error);
		});
	}

	pagetitle = "RMA";
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: this.apiService.getDashboardURL("hc"),
			name: this.pagetitle
		}
	];
	dateFilter = this.apiService.getDefaultDateRange(true);
	currentAccordion = "InvoiceModuleAlerts";
	/* symptoms: string[] = ['ILLNESS', 'PSYCHOLOGICAL', 'SURGERY', 'INJURY', 'ROUTINE HEALTH CHECK']; */
	/* humanAnatomyFilters: any = {
		symptom: { group_name: "INJURY", hc_id: 255 },
		sub_symptom: null
	} */

	getColorClass(value: number): string {
		if (value >= 1 && value <= 9) {
			return 'range-1-9';
		} else if (value >= 10 && value <= 25) {
			return 'range-10-25';
		} else if (value >= 26 && value <= 50) {
			return 'range-26-50';
		} else if (value >= 51 && value <= 75) {
			return 'range-51-75';
		} else if (value >= 76 && value <= 100) {
			return 'range-76-10000';
		} if (value >= 101 && value <= 10000) {
			return 'range-101-10000';
		} else {
			return '';
		}
	}

	top_5_med_cases: any[] = [];
	top5CasesLoader = false;
	rma_dashboard_top_5_med_cases_graph(): void {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			rank: this.cardsFilter.rank,
			nationality: this.cardsFilter.nationality,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
		};
		this.top5CasesLoader = true;
		this.apiService.rma_dashboard_top_5_med_cases_graph(filter).subscribe({
			next: ({ data_list }: any) => {
				this.top5CasesLoader = false;
				this.top_5_med_cases = data_list.map(({ name, value }: any) => ({ name, value }));
			}, error: () => {
				this.top5CasesLoader = false;
				this.top_5_med_cases = [];
			}
		});
	}

	symptoms_dropdown: any = [];
	rma_dashboard_symptoms_dropdown() {
		this.apiService.rma_dashboard_symptoms_dropdown({}).subscribe({
			next: (data: any) => {
				this.symptoms_dropdown = data.symptoms_list;
			}, error: (error) => {
				this.symptoms_dropdown = [];
			}
		});
	}

	subSymptoms_dropdown1: any = [];
	rma_dashboard_sub_symptoms_dropdown() {
		this.cardsFilter.sub_symptom = null;
		let payload: any = {};
		payload["symptom"] = this.cardsFilter.symptom ? this.cardsFilter.symptom.hc_id : null;
		if (!payload["symptom"]) {
			this.subSymptoms_dropdown1 = [];
			return;
		}
		this.apiService.rma_dashboard_sub_symptoms_dropdown(payload).subscribe({
			next: (data: any) => {
				this.subSymptoms_dropdown1 = data.sub_symptoms_rows;
			}, error: (error) => {
				this.subSymptoms_dropdown1 = [];
			}
		});
	}

	nationalities_dropdown: any = [];
	rma_dashboard_nationality_dropdown() {
		this.apiService.getCountryDetails({}).subscribe({
			next: (data: any) => {
				data.data = data.data.filter((val: any) => val.hc_id)
				this.nationalities_dropdown = data.data;
			}, error: (error) => {
				this.nationalities_dropdown = [];
			}
		});
	}

	companyList_dropdown: any = [];
	rma_dashboard_company_dropdown() {
		/* this.apiService.rma_dashboard_company_dropdown({}).subscribe((data: any) => {
			this.companyList_dropdown = data.company_list;
		}, (error) => {
			this.companyList_dropdown = [];
		}); */
		this.apiService.getCompanyDetails({}).subscribe({
			next: (data: any) => {
				data.data = data.data.filter((comp: any) => comp.hc_id)
				this.companyList_dropdown = data.data;
			}, error: (error) => {
				this.companyList_dropdown = [];
			}
		});
	}

	fleetList_dropdown1: any = [];
	rma_dashboard_fleet_dropdown(companyFilter: number) {
		let payload: any = {};
		if (companyFilter == 1) {
			payload["id"] = this.cardsFilter.company_id ? this.cardsFilter.company_id.id : null;
		}
		if (!payload["id"]) {
			if (companyFilter == 1) {
				this.fleetList_dropdown1 = [];
			}
			return;
		}
		this.apiService.getFleetsByCompany(payload).subscribe({
			next: (data: any) => {
				if (companyFilter == 1) {
					data.data = data.data.filter((flt: any) => flt.hc_id);
					this.fleetList_dropdown1 = data.data;
					if (this.fleetList_dropdown1.length == 1) {
						this.cardsFilter.fleet_id = this.fleetList_dropdown1[0];
						this.rma_dashboard_vessel_dropdown();
					}
				}
			}, error: (error) => {
				if (companyFilter == 1) {
					this.fleetList_dropdown1 = [];
				}
			}
		});
	}

	vessel_dropdown: any = [];
	rma_dashboard_vessel_dropdown() {
		let payload: any = {};
		payload["id"] = this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.id : null;
		if (!payload["id"]) {
			this.vessel_dropdown = [];
			return;
		}
		/* this.apiService.rma_dashboard_vessel_dropdown(payload).subscribe((data: any) => {
			this.vessel_dropdown = data.vessel_list;
		}, (error) => {
			this.vessel_dropdown = [];
		}); */
		this.apiService.getVesselsByFleet(payload).subscribe({
			next: (data: any) => {
				data.data = data.data.filter((ves: any) => ves.hc_id);
				this.vessel_dropdown = data.data;
			}, error: (error) => {
				this.vessel_dropdown = [];
			}
		});
	}
	//sym_card_data:any = [];
	// getAllTags(data) {
	// 	this.rma_dashboard_symptoms_tags_graph();
	// 	this.sym_card_data = data;
	// 	this.showCard = true;
	//   }

	//   mouseLeave() {
	// 	this.showCard  = false;
	//   }

	progress_bar_data: any = [];
	subCatName: any = [];
	progressDataLoader = false;
	rma_dashboard_sub_symptoms_graph() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			rank: this.cardsFilter.rank,
			nationality: this.cardsFilter.nationality,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			/* symptom: sym || "ILLNESS", */
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : "INJURY",
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
		};
		this.progressDataLoader = true;
		this.apiService.rma_dashboard_sub_symptoms_graph(filter).subscribe({
			next: (data: any) => {
				this.progressDataLoader = false;
				const total = data.total_appt_sub_symp_count;
				this.subCatName = filter.symptom;
				this.progress_bar_data = data.data_list.map((item: any) => ({
					name: item.name,
					value: ((item.value / total) * 100).toFixed(2)
				})).sort((a, b) => b.value - a.value);
			}, error: (error: any) => {
				this.progressDataLoader = false;
				this.progress_bar_data = [];
			}
		});
	}

	pinobj: any = {};
	editHumanBody = false;
	humanAnatomyPoints: any = '';
	allPainPointsOfAnatomy: any = [];
	spotsconfiga: any;
	spotsconfigb: any;
	spotsconfiga2: any;
	spotsconfigb2: any;
	selectedPoints: any = [];
	humanBodyLoader = false;

	humanAnatomyAPIs() {
		// Initialize configurations
		this.removeAllPoints();
		this.spotsconfiga = { pins: [] };
		this.spotsconfigb = { pins: [] };
		this.spotsconfiga2 = [];
		this.spotsconfigb2 = [];

		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			rank: this.cardsFilter.rank,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			nationality: this.cardsFilter.nationality,
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
		};
		this.humanBodyLoader = true;
		this.apiService.rma_dashboard_human_chart(filter).subscribe({
			next: (data: any) => {
				this.humanBodyLoader = false;
				const { MF_data_list, MB_data_list } = data;
				this.spotsconfiga.pins = MF_data_list;
				this.spotsconfigb.pins = MB_data_list;
				this.displayHumanAnatomy();
			},
			error: (error) => {
				this.humanBodyLoader = false;
				console.error("Error fetching data:", error);
				// Handle error appropriately here (e.g., show a message)
			}
		});
	}

	removeAllPoints() {
		$(".human_body_point").remove();
		/* const removeCircle = (pins: any, svgContainerId) => {
			pins.forEach((pin: any, index: any) => {
				$(`#${svgContainerId}_${index}`).remove();
			});
		};
		const spotsConfigA = this.spotsconfiga.pins || [];
		const spotsConfigB = this.spotsconfigb.pins || [];
		removeCircle(spotsConfigA, "anaspotsa");
		removeCircle(spotsConfigB, "anaspotsb"); */
	}

	displayHumanAnatomy() {
		const createSvgCircle = (pins: any, spotsConfig: any, svgContainerId) => {
			const xmlns = "http://www.w3.org/2000/svg";
			const svgContainer = document.getElementById(svgContainerId);

			pins.forEach((pin: any, index: any) => {
				const isSelected = spotsConfig.some(config => config.human_anatomy_id__id === pin.human_anatomy_id__id);
				const color = isSelected ? pin.selectedColor : pin.upColor;

				$(`#${svgContainerId}_${index}`).remove();

				const svgCircle = document.createElementNS(xmlns, "circle");
				svgCircle.setAttributeNS(null, "cx", pin.human_anatomy_id__x_axis);
				svgCircle.setAttributeNS(null, "cy", pin.human_anatomy_id__y_axis);
				svgCircle.setAttributeNS(null, "r", "15");
				svgCircle.setAttributeNS(null, "fill", "#f72119");
				svgCircle.setAttributeNS(null, "stroke", color);
				svgCircle.setAttributeNS(null, "stroke-width", "1");
				svgCircle.setAttributeNS(null, "cursor", "pointer");
				svgCircle.setAttributeNS(null, "class", "human_body_point");
				svgCircle.setAttributeNS(null, "id", `${svgContainerId}_${index}`);
				svgCircle.setAttributeNS(null, "body_part", pin.human_anatomy_id__body_part);

				const title = document.createElementNS(xmlns, "title");
				title.textContent = `Body Part: ${pin.human_anatomy_id__body_part} / Cases: ${pin.dcount}`;
				title.setAttributeNS(null, "class", 'title');

				svgCircle.appendChild(title);
				if (svgContainer) {
					svgContainer.appendChild(svgCircle);
				}
			});
		};

		const spotsConfigA = this.spotsconfiga.pins || [];
		const spotsConfigB = this.spotsconfigb.pins || [];

		createSvgCircle(spotsConfigA, this.spotsconfiga2, "anaspotsa");
		createSvgCircle(spotsConfigB, this.spotsconfigb2, "anaspotsb");
	}


	remove(item: any) {
		let index = this.selectedPoints.indexOf(item);
		this.selectedPoints.splice(index, 1);
	}

	ranks_dropdown: any = [];
	rma_dashboard_rank_dropdown() {
		/* this.apiService.rma_dashboard_rank_dropdown({}).subscribe((data: any) => {
			this.ranks_dropdown = data.rank_list;
		}, (error) => {
			this.ranks_dropdown = [];
		}); */
		this.apiService.getRankDetails({}).subscribe({
			next: (data: any) => {
				data.data = data.data.filter((val: any) => val.hc_id)
				this.ranks_dropdown = data.data;
			}, error: (error) => {
				this.ranks_dropdown = [];
			}
		});
	}

	owners_dropdown: any = [];
	disableOwner = false;
	get_owners_dropdown() {
		if (this.cardsFilter.company_id) {
			this.apiService.getOwnersByCompany({ company_id: this.cardsFilter.company_id.hc_id }).subscribe({
				next: (data: any) => {
					data.data = data.data.filter((val: any) => val.hc_id);
					this.owners_dropdown = data.data;
					if (this.user?.Email == "poojaria@angloeastern.com") {
						try {
							let owner = this.owners_dropdown.filter((owner: any) => owner.name == "RTM")[0];
							if (owner) {
								this.cardsFilter.owner_id = owner;
								this.disableOwner = true;
							}
						} catch (error) { }
					}
					this.getCompanyWiseData();
				}, error: (error) => {
					this.owners_dropdown = [];
					this.getCompanyWiseData();
				}
			});
		} else {
			this.owners_dropdown = [];
			this.getCompanyWiseData();
		}
	}
	arc_width = 0.25;
	pieChartLegendPosition: LegendPosition = LegendPosition.Right;
	pieChartLegendPositionBelow: LegendPosition = LegendPosition.Below;

	colorArr = ["#198754", "#FFC107", "#0D6EFD", "#0DCAF0", "#DC3545", "#6C757D", "#6b5b95", "#86af49",
		"#c94c4c", "#bc5a45", "#EF46DD", "#D75D5E", "#4B0082", "#005792", "#6643b5"
	];
	getRandomColor() {
		const letters = '0123456789ABCDEF';
		let color = '#';
		for (var i = 0; i < 6; i++) {
			color += letters[Math.floor(Math.random() * 16)];
		}
		return color;
	}
	view: any[] = [700, 300];
	symptomPieChartColors: any[] = [];
	symptoms_chart_loader = false;
	symptoms_chart_data: any = [];
	rma_dashboard_company_period_wise_count() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			rank: this.cardsFilter.rank,
			nationality: this.cardsFilter.nationality,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
		};

		this.company_period_wise_count_loader = true;

		this.apiService.rma_dashboard_company_period_wise_count(filter).subscribe({
			next: (data: any) => {
				this.company_period_wise_count_loader = false;
				this.company_period_wise_count = data;
				if (
					this.company_period_wise_count.total_cases == 0 &&
					this.company_period_wise_count.total_vessels == 0 &&
					this.company_period_wise_count.med_sign_off_count == 0 &&
					this.company_period_wise_count.avoid_med_sign_off_count == 0 &&
					this.company_period_wise_count.med_evacuation_count == 0 &&
					this.company_period_wise_count.avoid_med_evacuation_count == 0 &&
					this.company_period_wise_count.port_visit_count == 0 &&
					this.company_period_wise_count.recovered_count == 0
				) {
					this.all_zero_company_period_wise_count = true;
				} else {
					this.all_zero_company_period_wise_count = false;
				}
			},
			error: () => {
				this.company_period_wise_count_loader = false;
				this.all_zero_company_period_wise_count = true;
				this.company_period_wise_count = {};
			},
			complete: () => { }
		});
	}


	cases_by_month_data: any[] = [];
	case_loader: any = false;
	max: any = null;
	rma_dashborad_cases_by_month(): void {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			rank: this.cardsFilter.rank,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			nationality: this.cardsFilter.nationality,
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
			year: this.cardsFilter.year,
		};
		this.case_loader = true;
		this.apiService.getCasesByMonth(filter).subscribe({
			next: (data: any) => {
				const seriesData = data.data_list.slice(0, 12).map((item: any) => ({
					name: item.name,
					value: item.value
				}));
				try {
					const seriesDataCopy = JSON.parse(JSON.stringify(seriesData));
					this.max = seriesDataCopy.sort((a, b) => b.value - a.value)[0].value + 200;
					if (isNaN(this.max)) {
						this.max = null;
					}
				} catch (error) {
					this.max = null;
				}
				if (this.max != null) {
					this.yAxisTicks = [];
					let num = 0;
					do {
						this.yAxisTicks.push(num);
						num += 300;
					} while (num < this.max);
				}

				this.cases_by_month_data = [{
					name: "Cases",
					series: seriesData
				}];
				this.case_loader = false;
			}, error: () => {
				this.cases_by_month_data = [];
				this.case_loader = true;
			}
		});
	}

	yAxisTickFormattingFn(value: number): string {
		return value % 1 === 0 ? value.toString() : '';
	}

	getHeightWidthMonthlyCases() {
		return $('#monthWiseCasesChartDiv').width();
	}

	case_category_pie_chart_data: any[] = [];
	case_closure_pie_chart_colors: any[] = [];
	case_cat: any = false;
	rma_dashboard_case_category_pie_chart() {
		const filter = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
			fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
			owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
			vessel_id: this.cardsFilter.vessel_id,
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
			rank: this.cardsFilter.rank,
			nationality: this.cardsFilter.nationality,
			symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
			sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null,
		};
		this.case_cat = true;
		this.apiService.rma_dashboard_case_category_pie_chart(filter).subscribe({
			next: (data: any) => {
				this.case_cat = false;
				const total_rank = data.total_appt_symp_count;
				this.case_category_pie_chart_data = data.data_list.map((item: any) => ({
					name: item.name,
					value: ((item.value / total_rank) * 100).toFixed(2),
				}));
			}, error: (error: any) => {
				this.case_cat = false;
				this.case_category_pie_chart_data = [];
				this.case_closure_pie_chart_colors = [];
			}
		});
	}

	getWidthCaseCategoryPieChartDiv() {
		return $('#caseCategoryPieChartDiv').width();
	}

	dateFormat(date: Moment): string {
		return date.format('YYYY-MM-DD');
	}

	getTime(): string {
		return moment().format('DD/MM/YYYY__h:mm:ss__A');
	}

	analytic_data(): void {
		let analyticsData = {
			user_id: this.cardsFilter.user_id,
			start_date: this.dateFormat(this.cardsFilter.start_date_analytics),
			end_date: this.dateFormat(this.cardsFilter.end_date_analytics),
			doctor_id: this.params.selectDoctor,
			case_status: this.params.selectStatus

		};
		let date = this.getTime();
		this.apiService.analytic_data(analyticsData).subscribe({
			next: res => {
				let excelData: any = res.body;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = "hc_analytics_data__" + date + ".xlsx";
				FileSaver.saveAs(blob, fileName);
				this.params.selectDoctor = '';
				this.params.selectStatus = '';

			}, error: (error) => {
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		})
	}

	setCompany(comp: any) {
		if (comp) {
			sessionStorage.setItem("selectedCompanyFilter", JSON.stringify(comp));
		} else {
			sessionStorage.removeItem("selectedCompanyFilter");
		}
	}

	sendLoader = false;
	sendAnalytics() {
		Swal.fire({
			title: 'Please Confirm',
			text: 'You will receive an email containing the details. Do you want to continue?',
			icon: 'info',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				let analyticsData = {
					company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.hc_id : null,
					fleet_id: this.cardsFilter.fleet_id ? this.cardsFilter.fleet_id.hc_id : null,
					vessel_id: this.cardsFilter.vessel_id,
					start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
					end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
					rank: this.cardsFilter.rank,
					nationality: this.cardsFilter.nationality,
					owner_id: this.cardsFilter.owner_id ? this.cardsFilter.owner_id.hc_id : null,
					symptom: this.cardsFilter.symptom ? this.cardsFilter.symptom.group_name : null,
					sub_symptom: this.cardsFilter.sub_symptom ? this.cardsFilter.sub_symptom.group_name : null
				}
				this.sendLoader = true;
				this.apiService.rma_data_download(analyticsData).subscribe({
					next: res => {
						this.sendLoader = false;
						Swal.fire("Please check your email", "We will send you email, please chek your mail box after some time.", "info");
					}, error: (error) => {
						this.sendLoader = false;
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					}
				})
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}
}
